import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { customerRequestsService } from '../../services/customerRequests/customerRequestsService';
import type { AdminCustomerRequestDetailDto, CustomerRequestCreateInput } from '../../services/customerRequests/types';
import { secondaryText } from '../../styling/stylingHelper';
const cache = new Map<string, { at: number; result: Promise<AdminCustomerRequestDetailDto[]> }>();
export function announceCustomerRequestChange() {
  cache.clear();
  window.dispatchEvent(new Event('customer-requests-changed'));
}
export function RequestSourceStatus({ restaurantId, source, type, productName, identity }: {
  restaurantId: string; source: NonNullable<CustomerRequestCreateInput['source']>; type?: string; productName?: string; identity: string;
}) {
  const { t } = useTranslation();
  const [items, setItems] = useState<AdminCustomerRequestDetailDto[]>([]);
  const [error, setError] = useState(false);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    const update = () => setRefresh(value => value + 1);
    window.addEventListener('customer-requests-changed', update);
    return () => window.removeEventListener('customer-requests-changed', update);
  }, []);
  useEffect(() => {
    let active = true;
    const key = `${identity}:${restaurantId}:${source.kind}:${source.id}:${type ?? ''}`;
    let request = cache.get(key);
    if (!request || Date.now() - request.at > 60_000) {
      request = { at: Date.now(), result: customerRequestsService.list({ restaurantId, sourceKind: source.kind, sourceId: source.id, type, limit: 200 }).then(result => result.items) };
      cache.set(key, request);
    }
    setItems([]); setError(false);
    void request.result.then(result => { if (active) setItems(result); }).catch(() => { cache.delete(key); if (active) setError(true); });
    return () => { active = false; };
  }, [identity, restaurantId, source.kind, source.id, type, refresh]);
  const relevant = items.filter(item => {
    if (!productName) return true;
    const question = item.question;
    return question.type === 'ingredient_dish_usage' ? question.subject.name === productName : (question.type === 'ingredient_alternatives' || question.type === 'propose_alternative') ? question.primary.name === productName : question.type === 'product_quantity' ? question.product.name === productName : true;
  });
  if (error) return <button type="button" className={`text-xs ${secondaryText}`} onClick={() => setRefresh(value => value + 1)}>{t('customerRequests.retry')}</button>;
  return <>{relevant.slice(0, 3).map(item => <Link key={item.id} className={`text-xs underline ${secondaryText}`} to={`/admin/communication/customer-requests?requestId=${encodeURIComponent(item.id)}`} onClick={event => event.stopPropagation()}>{t('customerRequests.requestState', { status: t(`customerRequests.${item.status}`) })}</Link>)}</>;
}
